import { Injectable } from '@angular/core';
import {addProfile, createMapper} from '@automapper/core';
import {classes} from '@automapper/classes';
import {CommonAutoMapperProfile} from '../../typings/mappings/common/common-auto-mapper.profile';

@Injectable({
  providedIn: 'root'
})
export class MapperService {
  private readonly mapper = createMapper({
    strategyInitializer: classes(),
  });

  constructor() {
    addProfile(this.mapper, CommonAutoMapperProfile)
  }

  map<TSource, TDestination>(
    source: TSource,
    sourceReferenceKey: new () => TSource,
    destinationReferenceKey: new () => TDestination
  ): TDestination {
    return this.mapper.map(source, sourceReferenceKey, destinationReferenceKey);
  }

  mapArray<Source, Destination>(
    source: Source[],
    sourceReferenceKey: new () => Source,
    destinationReferenceKey: new () => Destination
  ): Destination[] {
    return this.mapper.mapArray(source, sourceReferenceKey, destinationReferenceKey);
  }
}
